import React, { useEffect, useState } from 'react';
import CheckIcon from '../svg/CheckIcon';

const Notification = ({ message, type = 'success', onClose }) => {
  const [visible, setVisible] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setVisible(false); // start fade-out animation
          setTimeout(() => onClose(), 500); // wait for animation
          return 100;
        }
        return prev + 1;
      });
    }, 30); // ~3 seconds total (30ms * 100 steps)
    return () => clearInterval(interval);
  }, [onClose]);

  const typeStyles = {
    success: '#05603A',
    error: '#EF4444',
    info: '#3B82F6',
    warning: 'black',
  };

  const animationStyles = visible
    ? 'opacity-100 translate-y-0 scale-100'
    : 'opacity-0 -translate-y-2 scale-95';

  return (
    <div
      className={`w-75 absolute top-2 right-2 z-100 rounded-t-[10px] rounded-bl-[10px] rounded-br-[5px] bg-white border border-[#ECFDF3] shadow-sm transform transition-all duration-500 ease-in-out ${animationStyles}`}
    >
      <div className="relative text-[#252B37] text-sm font-medium">
        <div className="p-4 space-x-4 flex items-center justify-between">
          <div>
            <div className="w-10 h-10 rounded-full bg-[#D1FADF] flex items-center justify-center">
              <CheckIcon size="w-6 h-6" color={typeStyles[type]} />
            </div>
          </div>
          <div className="w-full text-[#252B37] text-sm leading-[22px] tracking-[0%] font-medium">
            {message}
          </div>
        </div>

        <div className="absolute bottom-[-1px] w-full rounded-b-[10px] h-[5px] bg-gray-200 overflow-hidden">
          <div
            className="bg-[#12B76A] h-[5px] rounded-tl-[10px] rounded-bl-[10px] rounded-br-[20px] transition-all duration-100 ease-linear"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
